import * as React from 'react';

function SvgPicEmptyPayoutPlan(props) {
  return (
    <svg width={320} height={270} fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
      <path fill="#fff" d="M0 0h320v270H0z" />
      <path
        d="M230.583 146.135s-10.533 6.893-19.439 6.187c-8.905-.706-14.461-9.554-17.443-12.767-2.98-3.212-10.491-10.973-8.238-14.228 2.254-3.255 4.257.25 5.008 2.504.751 2.253.012-2.239 1.134-1.996 1.119.243.673 2.97 1.773 3.861 1.099.888 17.373 9.401 20.879 8.901 3.505-.501 5.04-1.463 6.026-2.484.984-1.024 11.605 7.797 10.3 10.022z"
        fill="#F8AE9D"
      />
      <path
        d="M196.143 229.977l-.027 4.719-10.784 5.811v2.542h21.567v-4.357l1.129-8.715h-11.885z"
        fill="#252525"
      />
      <path
        d="M250.24 172.402s-29.773-10.175-43.523-8.52c-13.543 2.754-13.646 19.088-13.596 28.698.05 9.609 1.645 37.401 1.645 37.401h15.138s5.416-24.995 7.223-36.785c0 0 .744-5.278 4.728-3.275 16.309 8.202 26.554 4.507 28.415-3.255 1.86-7.761-.03-14.264-.03-14.264z"
        fill="#2F3676"
      />
      <path
        d="M237.931 128.844s-9.742 4.795-17.664 5.994c-8.262 1.252 3.255 12.018 12.268 12.018 9.014 0 5.396-18.012 5.396-18.012z"
        fill="#FCCE01"
      />
      <path
        d="M278.134 235.774l5.778.028 5.391 7.261h2.696v-20.336h-4.621l-9.244 1.843v11.204z"
        fill="#252525"
      />
      <path
        d="M278.152 236.24v-12.518c-12.216-1.252-16.993-1.4-29.823-1.46-9.213-.043-4.434-2.546-4.434-2.546 10.09-7.011 20.449-24.036 20.449-24.036 6.106-9.515 2.656-24.287 2.656-24.287s-11.154 3.255-20.714 2.754c0 0-10.355 12.769-28.415 40.811-7.216 11.205-6.389 23.496 7.164 24.142 0 0 32.669.395 53.117-2.86z"
        fill="#2F3676"
      />
      <path
        d="M241.4 127.497s-8.612 1.582-9.667 12.734c-.786 8.322-.137 19.609-.137 23.24 0 3.63-1.851 3.325.691 4.414 2.541 1.089 16.024 12.018 34.532 3.575 0 0 2.889-16.73 2.023-26.86-.546-6.372-2.254-16.775-13.28-17.669l-14.162.566z"
        fill="#FCCE01"
      />
      <path
        d="M243.983 110.136l-4.735-.11s-3.91 17.126 5.774 15.178l-.183 1.808s-2.961.433-4.083.683c0 0 3.36 2.892 7.406 2.569 4.046-.323 6.868-2.959 6.868-2.959l-1.988-.201-.737-7.19s2.314-1.228 2.459-2.672c.145-1.445-.18-1.843-1.226-2.314-1.047-.47-2.675 1.192-2.675 1.192s-1.479-3.432-1.622-5.638l-5.258-.346z"
        fill="#F8AE9D"
      />
      <path
        d="M198.483 119.315l71.803 59.054a5.653 5.653 0 01-7.111 8.788l-72.954-58.328 8.262-9.514z"
        fill="#8C8C8C"
      />
      <path
        d="M172 73c17.674 0 32 14.326 32 32s-14.326 32-32 32-32-14.326-32-32 14.326-32 32-32zm0 54.624c12.494 0 22.623-10.129 22.623-22.624 0-12.494-10.129-22.623-22.623-22.623-12.495 0-22.624 10.129-22.624 22.623 0 12.495 10.129 22.624 22.624 22.624z"
        fill="#38B2A6"
      />
      <path
        d="M258.879 166.917s-10.534 6.893-19.439 6.187c-8.906-.707-14.463-9.555-17.444-12.767-2.98-3.213-10.491-10.974-8.238-14.229 2.254-3.255 4.256.25 5.008 2.504.751 2.253.013-2.238 1.134-1.996 1.119.243.673 2.97 1.773 3.861 1.099.889 17.373 9.402 20.879 8.901 3.505-.501 5.039-1.462 6.026-2.484.984-1.024 11.605 7.797 10.301 10.023z"
        fill="#F8AE9D"
      />
      <path
        d="M268.08 139.25s.511 16.119-3.245 22.879c-3.755 6.76-4.023 6.981-7.521 3.365-3.495-3.615-9.755-7.27-8.878-10.2.876-2.929 2.676-7.984 3.38-12.444.751-4.757 2.504-14.521 6.259-15.773 0 0 8.994 3.317 10.005 12.173z"
        fill="#FCCE01"
      />
      <path
        d="M254.477 119.811c-.773 1.235-2.627 1.229-2.301-.192.37-1.614.6-3.754-.776-3.501-1.376.253-1.56 1.311-2.04.63-.48-.68-.204-3.302-4.154-3.918-3.95-.614-5.712.589-7.468-.422-1.052-.605-1.401-1.85-1.511-2.752-.032-.255.187-.585.333-.372.137.201.535.232.446.006-.555-1.4-1.285-4.4 1.612-6.261 3.88-2.492 7.308-.212 9.358.137 4.516.768 7.422 1.359 8.582 4.5.961 2.605.086 8.688-2.081 12.145z"
        fill="#191847"
      />
      <path
        d="M215.324 54.682a6.52 6.52 0 100 13.04 6.52 6.52 0 000-13.04zM290.209 67.18a3.556 3.556 0 100 7.111 3.556 3.556 0 000-7.112zM153.259 184.897c-5.561 0-10.07-4.509-10.07-10.071 0-5.562 4.509-10.07 10.07-10.07 5.562 0 10.071 4.508 10.071 10.07s-4.509 10.071-10.071 10.071zM279.574 166.652a4.7 4.7 0 110-9.4 4.7 4.7 0 010 9.4z"
        fill="#89C5CC"
      />
      <path
        d="M131.486 58.244a6.042 6.042 0 110-12.084 6.042 6.042 0 010 12.084zM170.761 224.401a8.728 8.728 0 110-17.457 8.728 8.728 0 010 17.457z"
        fill="#F2F2F2"
      />
      <path
        d="M101.755 239.894a6.643 6.643 0 110-13.286 6.643 6.643 0 010 13.286z"
        fill="#E1E4E5"
      />
      <path
        d="M273.759 97.099c-1.964 0-3.556-1.725-3.556-3.853 0-2.127 1.592-3.852 3.556-3.852s3.556 1.724 3.556 3.852-1.592 3.853-3.556 3.853z"
        fill="#F2F2F2"
      />
      <path
        d="M54.76 32.71a2.76 2.76 0 110-5.52 2.76 2.76 0 010 5.52zM292.735 206.77c-2.713 0-4.912-1.737-4.912-3.878 0-2.142 2.199-3.878 4.912-3.878s4.912 1.736 4.912 3.878c0 2.141-2.199 3.878-4.912 3.878z"
        fill="#E1E4E5"
      />
      <path
        d="M167.999 36.637a4.801 4.801 0 11-9.275 2.484 4.801 4.801 0 019.275-2.484z"
        fill="#F2F2F2"
      />
      <path
        d="M71.623 69.753h32.051m-31.801 15.9h53.003m-.001 37.103H71.623m53.253-15.901H71.873"
        stroke="#F2F2F2"
        strokeWidth={6.5}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M43.072 126.056c5.854 0 10.6-4.746 10.6-10.6 0-5.855-4.746-10.601-10.6-10.601-5.855 0-10.601 4.746-10.601 10.601 0 5.854 4.746 10.6 10.6 10.6zM51.127 74.937L40.283 85.77l-5.27-5.253"
        stroke="#C1DEE2"
        strokeWidth={6.5}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M71.623 152.753h32.051m-31.801 15.901h53.003m-.001 37.102H71.623m53.253-15.901H71.873"
        stroke="#F2F2F2"
        strokeWidth={6.5}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M43.072 208.056c5.854 0 10.6-4.746 10.6-10.6 0-5.855-4.746-10.601-10.6-10.601-5.855 0-10.601 4.746-10.601 10.601 0 5.854 4.746 10.6 10.6 10.6zM51.127 157.937l-10.844 10.834-5.27-5.253"
        stroke="#C1DEE2"
        strokeWidth={6.5}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
}

export default SvgPicEmptyPayoutPlan;
